module.exports = __webpack_public_path__ + "static/media/river-background.204885dc.png";